<script>
  import HeaderMenuRow from "./HeaderMenuRow.svelte";
  export let data;

  const label = "Primary Product Menu";
  const id = "primary-nav-product";
</script>

<nav aria-label={label} class="lg:order-2 order-1 bg-white">
  <h2 {id} class="sr-only">{label}</h2>
  <HeaderMenuRow
    on:click
    on:urlDispatch
    {data}
    class="lg:px-72 lg:py-[36px] lg:h-96"
    labelledby={id}
  />
</nav>
